<p>stringcheck works!</p>
